import React from 'react'
import Translations from '@helpers/translations'
import Stars from '@components/ui/Stars'
import styles from './reviewItemStyles.module.scss'

export type ReviewItemProps = {
  title: string
  description: string
  author: string
  stars: number
  location?: string
}

function ReviewItem({
  title,
  description,
  stars,
  author,
  location
}: ReviewItemProps) {
  return (
    <article className={styles.ReviewItem}>
      <div className={styles.ReviewItem__rating}>
        <Stars value={stars} color="color2" />
      </div>
      <div className={styles.ReviewItem__copy}>
        {title && <h3 className={styles.ReviewItem__title}>{title}</h3>}
        <p className={styles.ReviewItem__description}>{description}</p>
      </div>

      <footer className={styles.ReviewItem__author}>
        <p>
          <span>{author}</span>
          {location
            ? ` ${Translations.localise('common.reviews.from')} ${location}`
            : ''}
        </p>
      </footer>
    </article>
  )
}

export default ReviewItem
